import type { Company, Direction, Driver } from "../api";
import Header from "../components/Header";

function BoxArrowIcon({ direction }: { direction: Direction }) {
  return (
    <svg
      viewBox="0 0 48 48"
      className="size-12"
      fill="none"
      stroke="currentColor"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      {direction === "in" ? (
        <path d="M24 5v16M16 13h16" />
      ) : (
        <path d="M16 13h16" />
      )}
      <path d="M8 28h32l-3 14H11l-3-14Z" />
    </svg>
  );
}

export default function Home({
  driver,
  company,
  onSwitchDriver,
  onHome,
  onRegister,
  onHistory,
}: {
  driver: Driver;
  company: Company | undefined;
  onSwitchDriver: () => void;
  onHome: () => void;
  onRegister: (direction: Direction) => void;
  onHistory: () => void;
}) {
  const balance = company?.balance ?? 0;
  // Status is shown from Soulcake's side: boxes out at Matsentralen read as negative.
  const statusNumber = balance === 0 ? 0 : -balance;

  return (
    <div className="flex flex-1 flex-col gap-5">
      <Header driver={driver} onSwitchDriver={onSwitchDriver} onHome={onHome} />

      <div className="flex items-center justify-center py-1">
        <img src="/matsentralen.png" alt="Matsentralen" className="max-h-12" />
      </div>

      <div className="grid grid-cols-2 gap-3">
        <button
          onClick={() => onRegister("in")}
          disabled={!company}
          className="flex h-44 flex-col items-center justify-center gap-2 rounded-[18px] bg-rose-grad text-white transition-transform active:scale-95 disabled:opacity-60 shadow-button"
        >
          <BoxArrowIcon direction="in" />
          <span className="text-[22px] font-bold tracking-[-0.02em]">Deliver</span>
          <span className="text-xs font-semibold opacity-80">boxes I brought in</span>
        </button>
        <button
          onClick={() => onRegister("out")}
          disabled={!company}
          className="flex h-44 flex-col items-center justify-center gap-2 rounded-[18px] border border-line-soft bg-white text-rose-ink shadow-card transition-transform active:scale-95 disabled:opacity-60"
        >
          <BoxArrowIcon direction="out" />
          <span className="text-[22px] font-bold tracking-[-0.02em]">Pick up</span>
          <span className="text-xs font-semibold opacity-70">boxes I took back</span>
        </button>
      </div>

      <button
        onClick={onHistory}
        className="rounded-[18px] bg-white p-5 text-left transition-transform active:scale-[0.99] border border-line-soft shadow-card"
      >
        <div className="flex items-baseline justify-between">
          <h2 className="text-[19px] font-bold tracking-[-0.02em]">Matsentralen status</h2>
          <span className="rounded-full bg-rose px-3 py-1 text-sm font-bold text-white">
            {statusNumber}
          </span>
        </div>
        <p className="pt-3 text-sm font-semibold text-ink/50">
          {balance === 0
            ? "No boxes out right now. Tap Deliver to register your first drop-off."
            : `${Math.abs(balance)} ${Math.abs(balance) === 1 ? "box" : "boxes"} at ${company?.name} right now. Tap to see the history.`}
        </p>
      </button>

      <button
        onClick={onHistory}
        className="mx-auto rounded-full bg-white px-6 py-3 font-bold border border-line"
      >
        History
      </button>
    </div>
  );
}
